"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Api_module_css_1 = __importDefault(require("./Api.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var CreateApiTokenModal_1 = __importDefault(require("./CreateApiTokenModal"));
var GenericList_1 = __importDefault(require("@/Components/common/GenericList"));
var AccessControl_1 = __importDefault(require("@/Components/common/AccessControl"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ziggy_js_1 = __importDefault(require("ziggy-js"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var q_play_core_2 = require("@nordicscreen/q-play-core");
var Api = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _g = (0, q_play_components_1.useModal)(), isShown = _g.isShown, toggle = _g.toggle;
    var page = (0, useTypedPage_1.default)();
    var logger = q_play_core_2.logManager.getLogger();
    function copyTokenToClipboard() {
        var _a, _b, _c;
        if (!((_c = (_b = (_a = page.props) === null || _a === void 0 ? void 0 : _a.jetstream) === null || _b === void 0 ? void 0 : _b.flash) === null || _c === void 0 ? void 0 : _c.token))
            return;
        navigator.clipboard.writeText(page.props.jetstream.flash.token).then(function () {
            logger.info("Copying to clipboard was successful!");
        }, function (err) {
            logger.error("Could not copy text: ", err);
        });
    }
    var openCreateApiTokenModal = function () {
        toggle();
    };
    var deleteToken = function (tokenId) {
        var request = onlineResourceManager.makeJSONRequest((0, ziggy_js_1.default)("api-tokens.destroy", tokenId), "DELETE");
        request.getResponseRaw().then(function () {
            window.location.reload();
        });
    };
    var columns = (0, react_1.useMemo)(function () { return ([
        {
            name: t("Token name"),
            dataIndex: "name"
        },
        {
            name: t("Last used"),
            dataIndex: "last_used_ago"
        },
        {
            name: t("Action"),
            dataIndex: "actions"
        },
    ]); }, [t]);
    var data = (0, react_1.useMemo)(function () {
        return props.tokens.map(function (token) { return (__assign(__assign({}, token), { actions: (react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                    {
                        permission: "edit-api",
                        children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Delete"), onClick: function () { return deleteToken(token.id); }, dataCy: "deleteApiToken" }))
                    },
                    {
                        permission: "see-api",
                        children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Delete"), disabled: true, dataCy: "deleteApiToken" }))
                    }
                ] })) })); });
    }, [props]);
    return (react_1.default.createElement("div", { className: Api_module_css_1.default["content-container"] },
        react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-end", style: { marginBottom: "5rem" } },
            react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                    {
                        permission: "edit-api",
                        children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Create"), onClick: openCreateApiTokenModal, dataCy: "createApiTokenModalButton" }))
                    },
                    {
                        permission: "see-api",
                        children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Create"), disabled: true, dataCy: "createApiTokenModalButton" }))
                    }
                ] })),
        react_1.default.createElement(GenericList_1.default, { data: data, columns: columns }),
        react_1.default.createElement(CreateApiTokenModal_1.default, { isShown: isShown, toggle: toggle }),
        ((_c = (_b = (_a = page.props) === null || _a === void 0 ? void 0 : _a.jetstream) === null || _b === void 0 ? void 0 : _b.flash) === null || _c === void 0 ? void 0 : _c.token) &&
            react_1.default.createElement("div", { style: { marginTop: "5rem" } },
                react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-center", style: { marginTop: "1rem" } },
                    react_1.default.createElement("p", null,
                        "Token: ",
                        react_1.default.createElement("span", { "data-cy": "createdToken" }, (_f = (_e = (_d = page.props) === null || _d === void 0 ? void 0 : _d.jetstream) === null || _e === void 0 ? void 0 : _e.flash) === null || _f === void 0 ? void 0 : _f.token),
                        "\u00A0")),
                react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-center", style: { marginTop: "1rem" } },
                    react_1.default.createElement(q_play_components_1.Button, { text: t("Copy to Clipboard"), onClick: copyTokenToClipboard, dataCy: "copyTokenToClipboardButton" })))));
};
exports.default = Api;
